import { ACCOUNT_TYPE } from "../workspace/seat-limit";
import { MODULE_ACTION_LIST } from "./module-action-list";
import { PRODUCT_MODULE_LIST } from "./product-module-list";
function fillModules(actionList) {
    return Object.fromEntries(PRODUCT_MODULE_LIST.map((module) => [module, actionList]));
}
function restrictModules(row, restrictedModuleList) {
    const overrideList = restrictedModuleList.map((module) => [module, []]);
    return { ...row, ...Object.fromEntries(overrideList) };
}
// Workspace-administration modules, not shared content: a guest gets no access
// to them at all, unlike the uniform view/update grant every other module gets.
const GUEST_RESTRICTED_MODULE_LIST = ["WORKSPACE_MEMBER", "WORKSPACE_SETTING", "ACTIVITY_LOG"];
export const ACCOUNT_TYPE_MODULE_ACTION = {
    [ACCOUNT_TYPE.CORE]: fillModules(MODULE_ACTION_LIST),
    [ACCOUNT_TYPE.GUEST]: restrictModules(fillModules(["view", "update",]), GUEST_RESTRICTED_MODULE_LIST),
};
